export default {
  zh: {
    oldPwd: '旧密码',
    newPwd: '新密码',
    confirmPwd: '确认新密码',
    confirmError: '新密码和确认密码不一致！',
    pwdTip: '密码不能少于8位，包含数字，大小写字母',
    hello: '{name},你好!',
    changeSuccess: '修改密码成功，请重新登录',
    uploadUserAvatar: '上传用户头像',
  },
  en: {
    oldPwd: 'Old Password',
    newPwd: 'New Password',
    confirmPwd: 'Confirm New Password',
    confirmError: 'New password is not same as to the confirm password',
    pwdTip: 'At least 8 characters including number,lower/upper capitals',
    hello: 'Hello, {name}!',
    changeSuccess: 'Modify password success, Please relogin',
    uploadUserAvatar: 'Upload User Avatar',
  },
};



// WEBPACK FOOTER //
// ./src/views/MySetting/i18n.js